import { prefetchCustomerQuery, useCustomerQuery } from '@/hooks/useCustomerQuery'
import { StripeApiService, type BillingHealthResponse } from '@/lib/http/stripe-api.service'

const BILLING_HEALTH_CACHE_KEY = 'billing-health'
const BILLING_HEALTH_TTL_MS = 5 * 60 * 1000

export function useBillingHealth() {
  return useCustomerQuery<BillingHealthResponse>({
    cacheKey: BILLING_HEALTH_CACHE_KEY,
    queryFn: () => StripeApiService.BillingHealth(),
    ttlMs: BILLING_HEALTH_TTL_MS,
  })
}

/**
 * Warms the banner's cache in parallel with bootstrap
 * (`layouts/customer/parallel-bootstrap-prefetch`), so the banner no longer
 * waits for the layout's loading gate to open before it even asks.
 */
export function prefetchBillingHealth(userId: string): Promise<BillingHealthResponse> {
  return prefetchCustomerQuery({
    cacheKey: BILLING_HEALTH_CACHE_KEY,
    userScopeKey: userId,
    queryFn: () => StripeApiService.BillingHealth(),
    ttlMs: BILLING_HEALTH_TTL_MS,
  })
}
